import { action } from 'typesafe-actions';
import { AnalyticsReport, ReportingViewState } from 'store/analytics/ui/analyticsUiTypes';
import {
  SELECT_MOCK_SERVICES,
  SELECT_REPORT,
  SET_DATE_RANGE,
  SET_FIXED_TIME_RANGE,
  SET_MS_SEARCH_KEYWORD,
  SET_REPORT_CONFIG,
  SET_RESOLUTION,
} from 'store/analytics/ui/subViews/reportingView/reportingViewActionTypes';
import {
  DateRange,
  FixedTimeRange,
} from 'views/Analytics/AnalyticsMockService/Reporting/Pickers/BzmDateRangePicker/BzmDateRangePicker';
import MixpanelService from 'utils/mixpanelService';
import { REPORT_SELECTED_TYPE } from 'utils/mixpanelEvents';

export const selectReport = (report: AnalyticsReport) => {
  MixpanelService.track(REPORT_SELECTED_TYPE(report.id));
  return action(SELECT_REPORT, report);
};
export const setDateRange = (dateRange: DateRange) => action(SET_DATE_RANGE, dateRange);
export const setResolution = (resolution: string) => action(SET_RESOLUTION, resolution);
export const setFixedTimeRange = (fixedTimeRange: FixedTimeRange | null) =>
  action(SET_FIXED_TIME_RANGE, fixedTimeRange);
export const setReportsConfig = (reportConfig: ReportingViewState) => action(SET_REPORT_CONFIG, reportConfig);
export const selectMockServices = (mockServicesIds: number[]) => action(SELECT_MOCK_SERVICES, mockServicesIds);
export const setMsSearchKeyword = (searchKeyword: string) => action(SET_MS_SEARCH_KEYWORD, searchKeyword);
